import { Injectable } from '@angular/core';
import { ICommand } from '@commands/interfaces';

@Injectable({ providedIn: 'root' })
export class NavigateOutsideApplicationCommand implements ICommand {
  public execute({ url, newTab = false }: { url: string; newTab?: boolean }): void {
    newTab ? window.open(url) : (window.location.href = url);
  }
}
